import { gql, useMutation } from '@apollo/client';

import {
  SetListingDetails,
  SetListingDetailsVariables,
} from '../../../graphql/athena/mutations/__generated__/SetListingDetails';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';
import { LWC_DETAILS_QUERY } from '../queries/LwcDetails';
import { PARN_DETAILS_QUERY } from '../queries/ParnDetails';

export const SET_LISTING_DETAILS = gql`
  mutation SetListingDetails($params: OdProtosListingsServices_SetDetailsRequestInput!) {
    odProtosListingsServicesListingmanagement {
      setDetails(input: $params) {
        _empty
      }
    }
  }
`;

/**
 * This is used to update the listing details on a home
 * Instead of taking the LWC product id, we need to provide the listing id which we can get from the LWC details call
 * Pass in an array of the fields you want to update along with the field values
 */
export const useSetListingDetails = () => {
  const [updateSetListingDetails, { data, error, loading }] = useMutation<
    SetListingDetails,
    SetListingDetailsVariables
  >(SET_LISTING_DETAILS, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY, PARN_DETAILS_QUERY],
  });

  const setListingDetails = (params: SetListingDetailsVariables) =>
    updateSetListingDetails({
      variables: params,
    });
  return { setListingDetails, data, loading, error };
};
